import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler,
    Text,
    TouchableWithoutFeedback,
    ScrollView, TextInput,
    StyleSheet,Button
} from "react-native";

import HMActionBar from "../../../customviews/HMActionBar";
import i18n from "../../../I18n/i18n";
import {typeExport} from "../../../redux/store/type";
import store from "../../../redux/store";


import axios from "axios";
import HMAlert from "../../../customviews/HMAlert";
import HMIcon from "../../../customviews/HMIcon";
import importFirebase from "../../../importCalss/firebase/importFirebase";
// import {GiftedChat} from "react-native-gifted-chat";
//import { ChatScreen } from 'react-native-easy-chat-ui'

let container = null;


let firebase=importFirebase;

export default class ChatMessageScreen extends Component {
    constructor(props) {
        super(props);
       // global._refreshListOpertor = true;


        container = this;
        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 1000 ? 2 : 1;

        }

        if (Platform.OS === "android") {

            //firebase = require("react-native-firebase")
            // alert(firebase)

        }
        this.state = {
            chats: [
                {
                    name:'احمد',
                    massage:'سلام',
                    self:true,
                    time:'10:22',
                },
                {
                    name:'مهرداد',
                    massage:'خوبی',
                    self:false,
                    time:'10:23',
                },
                {
                    name:'احمد',
                    massage:'ممنون خوبم',
                    self:true,
                    time:'10:24',
                },
                {
                    name:'احمد',
                    massage:'تو خوبی',
                    self:true,
                    time:'10:27',
                },
                {
                    name:'مهرداد',
                    massage:'فدات',
                    self:false,
                    time:'10:22',
                },
            ],
            /*   messages: [
                   {
                       id: `1`,
                       type: 'text',
                       content: 'hello world',
                       targetId: '12345678',
                       chatInfo: {
                           avatar:  PathFile.image.user,
                           id: '12345678',
                           nickName: 'Test'
                       },
                       renderTime: true,
                       sendStatus: 0,
                       time: '1542006036549'
                   },
                   {
                       id: `2`,
                       type: 'text',
                       content: 'hi/{se}',
                       targetId: '12345678',
                       chatInfo: {
                           avatar:  PathFile.image.user,
                           id: '12345678',
                           nickName: 'Test'
                       },
                       renderTime: true,
                       sendStatus: 0,
                       time: '1542106036549'
                   },
                   {
                       id: `3`,
                       type: 'image',
                       content: {
                           uri: 'https://upload-images.jianshu.io/upload_images/11942126-044bd33212dcbfb8.jpg?imageMogr2/auto-orient/strip|imageView2/1/w/300/h/240',
                           width: 100,
                           height: 80,
                       } ,
                       targetId: '12345678',
                       chatInfo: {
                           avatar:  PathFile.image.user,
                           id: '12345678',
                           nickName: 'Test'
                       },
                       renderTime: false,
                       sendStatus: 0,
                       time: '1542106037000'
                   },
                   {
                       id: `4`,
                       type: 'text',
                       content: '你好/{weixiao}',
                       targetId: '88886666',
                       chatInfo: {
                           avatar:  PathFile.image.user,
                           id: '12345678'
                       },
                       renderTime: true,
                       sendStatus: -2,
                       time: '1542177036549'
                   },
                   {
                       id: `5`,
                       type: 'voice',
                       content: {
                           uri: 'http://m10.music.126.net/20190810141311/78bf2f6e1080052bc0259afa91cf030d/ymusic/d60e/d53a/a031/1578f4093912b3c1f41a0bfd6c10115d.mp3',
                           length: 10
                       },
                       targetId: '12345678',
                       chatInfo: {
                           avatar:  PathFile.image.user,
                           id: '12345678',
                           nickName: 'Test'
                       },
                       renderTime: true,
                       sendStatus: 1,
                       time: '1542260667161'
                   },
                   {
                       id: `6`,
                       type: 'voice',
                       content: {
                           uri: 'http://m10.music.126.net/20190810141311/78bf2f6e1080052bc0259afa91cf030d/ymusic/d60e/d53a/a031/1578f4093912b3c1f41a0bfd6c10115d.mp3',
                           length: 30
                       },
                       targetId: '88886666',
                       chatInfo: {
                           avatar: PathFile.image.user,
                           id: '12345678'
                       },
                       renderTime: true,
                       sendStatus: 0,
                       time: '1542264667161'
                   },
               ],*/
            // chatBg: require('../../source/bg.jpg'),
            inverted: false,  // require
            voiceHandle: true,
            currentTime: 0,
            recording: false,
            paused: false,
            stoppedRecording: false,
            finished: false,
            audioPath: '',
            voicePlaying: false,
            voiceLoading: false,
            ////////////////


            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            //  textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',
            indexFilter: 0,


            /* dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                 name: 'در دست اقدام',
                 id: 2
             }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                 name: 'تایید واحد',
                 id: 5
             },],
             textCondition: null,
             arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                 name: 'تکراری در دست اقدام',
                 id: 3
             }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],*/
            Condition: {id: 0, value: "وضعیت پیام"},

            // arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            //   dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: [],
            trackingCode: null,
            showModal: false,
            results: null,
            inputhieght: {height:"11%"},

        };
        container = this;

        //
        // this.props.navigation.addListener('focus', () => {
        //         if (global._refreshListOpertor) {
        //             store.dispatch(serviceActionListFilter([]))
        //             props.callserviceActionRefresh();
        //             this.getData(1)
        //             global._refreshListOpertor = false
        //         }
        //
        //     }
        // )
        // )

    }

    state = {
        show: false
    };

    componentWillReceiveProps(props) {


        props.results && props.results.length > 0 && this.state.Once ?
            this.setState({
                    Once: false
                },
                () => {


                }
            )
            :
            null
    }


    async componentDidMount() {
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 1000 ? 2 : 1,
                    },
                )


            })

        // store.dispatch(serviceActionListFilter([]))
        // this.props.callserviceActionRefresh();
        // this.getData()


    }


    componentWillUnmount() {

    }


    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };


    render() {
        let {item, data} = this.props.route && this.props.route.params ? this.props.route.params : {};

        let {results} = this.state

        // let childFilter = result.items[this.state.indexFilter].list;
        let heightSlider = (this.state.viewportWidth > 600) ? 500 : (Platform.OS === "web" ? this.state.viewportWidth : typeExport.WIDTH) / 1.6;
        return (
            <View style={{position: 'relative', flex: 1}}>

                <KeyboardAvoidingView
                    keyboardVerticalOffset={-85}
                    style={{flex: 1}}
                    behavior="padding"
                >
                    <View>
                        <View style={styles.chatcontainer}>
                            <FlatList
                                keyExtractor={(item, index) => index.toString()}
                                ref={(ref) => {
                                    this.myref = ref;
                                }}
                                inverted
                                style={styles.flatlist}
                                data={this.state.chats}
                                renderItem={({item, index}) => {

                                    return <View style={{
                                        alignItems: item.self ? "flex-end" : "flex-start",
                                        justifyContent: item.self ? "flex-end" : "flex-start",
                                        height: "auto",
                                        flexDirection: "row",
                                        marginRight: item.self ? 10 : 0,
                                    }}>
                                        {!item.self ? (
                                            null
                                            //  {/*<Avatar.Text style={styles.avatar} size={37} label={item.name.split('')[0]+item.name.split('')[1]} />*/}
                                        ) : null}
                                        <View
                                            style={[styles.cha, {backgroundColor: item.self ? "#0084ff" : "#e3e3e3"}]}>
                                            {!item.self ? (
                                                <Text style={styles.id}>{item.name}</Text>
                                            ) : null}
                                            <Text textBreakStrategy={"highQuality"}
                                                  style={{color: item.self ? "white" : "black"}}>
                                                {item.massage}
                                            </Text>
                                            <Text
                                                style={[styles.time,{color: item.self ? "white" : "black"}]}>{item.time}</Text>
                                        </View>
                                    </View>
                                }}
                                contentContainerStyle={styles.list}
                                //onContentSizeChange={()=>{myref.scrollToEnd({animated:true})}}
                            />
                        </View>

                        <View style={[styles.massageinput_container,this.state.inputhieght]}>
                            <TextInput
                                onFocus={() => {
                                    this.setState({inputhieght: {height: 58}});
                                }}
                                onBlur={() => {
                                    //  setinputhieght({height: "11%"});
                                    this.setState({inputhieght: {height: "11%"}});

                                }}
                                style={styles.massage_input}
                                multiline
                                label="Massage ..."
                                onChangeText={(msg) => {
                                    this.setState({massage:msg});
                                }}
                                value={this.state.massage}
                                theme={{

                                    colors: {
                                        primary: '#0084ff',
                                    }
                                }}
                            />
                            <Button
                                style={styles.send_btn}
                                onPress={() => {
                                   // send();
                                }}
                                mode="text"
                            >{"dfgdfgfd"}
                                {/*<HMIcon name="paper-plane" size={25} color="#0084ff"/>*/}
                            </Button>
                        </View>
                    </View>
                </KeyboardAvoidingView>

            </View>
        );
    }
    prettyDate2 = (time) => {
        var date = time;
        var localeSpecificTime = date.toLocaleTimeString();
        return localeSpecificTime
            .replace(/:\d+ /, " ")
            .split(":")
            .splice(0, 2)
            .join(":");
    }
    sendMessage = (type, content, isInverted) => {
    }


    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }

    onShow(data) {
        container.setState({
            visibleModal: data,

        });
    }


    setLike(item, index) {

        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('record', item.id);
        formData.append('token', container.props.token);
        formData.append('_operation', typeExport._Registration);
        // // formData.append('lang', params.lang);
        formData.append('mode', "LikeTicket");


        store.dispatch(serviceActionSetLike(!item.like, index, {count_like: !item.like ? item.count_like + 1 : (item.count_like === 0 ? 0 : item.count_like - 1)}))


        this.requestServer((res) => {
            //  store.dispatch(serviceActionSetLike(!item.like, index,res))
        }, formData, false)
        // const some_array = [...this.state.list]
        //
        // some_array[index].like = !this.state.list[index].like
        //
        // this.setState({list: some_array}
        //     ,
        //     () => {
        //     }
        // )
    }

    getData() {
        const formData = new FormData();
        formData.append('lang', i18n.locale);
        //  formData.append('record', this.state.item.id);
        //   formData.append('record', "191609");
        //formData.append('record', this.props.route.params.id);
        let id= ((typeExport._NameApp === "Cloud"|| typeExport._NameApp === "CloudTest") ) && false?item.tracking_code :item.id;
        formData.append('record',id );
        formData.append('token', container.props.token);
        formData.append('_operation', typeExport._Registration);
        // // formData.append('lang', params.lang);
        formData.append('mode', "GetAlbumDetail");


        // store.dispatch(serviceActionSetLike(!item.like, index, {count_like: !item.like ? item.count_like + 1 : (item.count_like === 0 ? 0 : item.count_like - 1)}))
        //  if (store.getState().reducerSplashGetAllData.Connection) {
        //
        //      this.props.callService(typeExport._baseUrlSaina, paramss, typeExport.TypeGetGalleryServiceScreen, typeExport._POST, page, typeExport._Count, null)
        //
        //  } else {
        //      // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApply + item.type)
        //      // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApplyFilter + item.type)
        //      // store.dispatch(serviceActionListFilter(listFilter))
        //      // if (data != null)
        //      //     store.dispatch(serviceActionSuccess(data, 0))
        //      // else
        //      //     store.dispatch(serviceActionSuccess([], 0))
        //
        //      store.dispatch(serviceActionError('not connection', 1))
        //  }

        this.requestServer((res) => {
            this.setState({
                results: res
            })
            //   alert("djfhvj")
            //  store.dispatch(serviceActionSetLike(!item.like, index,res))
        }, formData)
    }

    requestServer(func, formData, noLoading) {

        container.setState({
            //ShowImage:true
            isLoading: !noLoading,
            NoInternetDialog: false,
            results: null


        })


        // const formData = new FormData();
        // formData.append('lang', i18n.locale);
        // formData.append('token', container.props.token);


        axios({
            method: 'post',
            url: typeExport._baseUrlSaina,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;

                // data.status ? this.state.listImage.push(image) : null;

                if (data.success) {
                    func ? func(data.result) : null
                    // container.getDataServerSplash()
                }
                else {
                    HMAlert(
                        i18n.t('constant.message'),
                        data.message,
                        [
                            {
                                text: i18n.t('constant.ok'), onPress: () => {

                                }


                            },

                        ],
                        {cancelable: true}
                    )
                }
                container.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.success,

                })
            }).catch((e) => {
            HMAlert(
                i18n.t('constant.message'),
                "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
                [
                    {
                        text: i18n.t('constant.ok'), onPress: () => {

                        }


                    },

                ],
                {cancelable: true}
            )
            container.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,

            })
            console.log('error', e)
        })
    }
}

const styles = StyleSheet.create({
    flatlist: {
        height: "88.1%",
        // backgroundColor: "#f5f5f5",
        backgroundColor: 'white',
        paddingBottom: 10,
    },
    massageinput_container: {
        position: "relative",
        alignContent: "center",
        justifyContent: "center",
        flexDirection: "row",
        borderTopWidth: 0.5,
        borderColor: '#b8b8b8'

    },
    send_btn: {
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        borderTopLeftRadius: 0,
    },
    massage_input: {
        width: "80%",
        backgroundColor: "white",
        borderTopRightRadius: 0,
        // elevation :1
    },
    chatcontainer: {
        paddingBottom: 10,
        backgroundColor: 'white'

    },
    hry: {
        height: 110,
        flexDirection: "row",
    },
    avatar: {
        marginLeft: 10,
        marginTop: 10,
    },
    cha: {
        height: "auto",
        maxWidth: "70%",
        marginLeft: 7,
        marginTop: 10,
        padding: 6.5,
        borderTopEndRadius: 10,
        borderTopLeftRadius: 10,
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
    },
    id: {
        fontWeight: "bold",
        marginBottom: 3,
    },
    time: {
        alignSelf: "flex-end",
    },
});
